module.exports = __webpack_public_path__ + "static/img/logo-mini-dark.e64b1d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-mini-dark.png
// module id = Gz6t
// module chunks = 11